import { PageLayout } from "components";
import Segment, { SegmentContainer } from "components/atoms/Segment";
import DataObjectDuplicateSearch from "containers/DataObjectDuplicateSearch";

const DataObjectDuplicateSearchPage = (props) => {
    return (
        <PageLayout
            border={false}
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return (
                    <SegmentContainer>
                        <Segment>
                            <DataObjectDuplicateSearch setBreadcrumbNavigationItems={setBreadcrumbNavigationItems} />
                        </Segment>
                    </SegmentContainer>
                );
            }}
        ></PageLayout>
    );
};

export default DataObjectDuplicateSearchPage;
